<template>
    <div>
        <div class="mb-3">
            <hr />
            <h5>{{ $t("wizard.form.title.citizen-profile") }}</h5>
            <p>{{ $t("wizard.form.title.search-citizen-data") }}</p>
        </div>
        <div class="row">
            <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                <b-alert
                    v-show="valid ? false : true"
                    show
                    dismissible
                    variant="danger"
                >
                    <i class="mdi mdi-block-helper mr-2"></i>Inputan tidak
                    boleh kosong
                </b-alert>
                <!-- <hr> -->
                <form
                    class="needs-validation"
                    @submit.prevent="searchData()"
                >
                    <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                        <label for="validationCustom01"
                            >{{ $t("form.citizen.label.name") }}
                            <span class="text-danger">*</span></label
                        >
                        <input
                            id="validationCustom01"
                            v-model="form.wizard2.nama"
                            type="text"
                            class="form-control"
                            :placeholder="
                            $t('form.citizen.placeholder.name')
                            "
                            :class="{
                            'is-invalid':
                                submitted && $v.form.wizard2.nama.$error,
                            }"
                        />
                        <div
                            v-if="
                            submitted && $v.form.wizard2.nama.$error
                            "
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.form.wizard2.nama.required"
                            >This value is required.</span
                            >
                        </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                        <label for="validationCustom02">{{
                            $t("form.citizen.label.nik")
                        }}</label>
                        <input
                            id="validationCustom02"
                            v-model="form.wizard2.nik"
                            type="text"
                            class="form-control"
                            :placeholder="
                            $t('form.citizen.placeholder.nik')
                            "
                            value="Otto"
                        />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                        <label for="validationCustom02">{{
                            $t("form.citizen.label.nkk")
                        }}</label>
                        <input
                            id="validationCustom02"
                            v-model="form.wizard2.nkk"
                            type="text"
                            class="form-control"
                            :placeholder="
                            $t('form.citizen.placeholder.nkk')
                            "
                        />
                        </div>
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                        <label for="validationCustom03">{{
                            $t("form.citizen.label.address")
                        }}</label>
                        <input
                            id="validationCustom03"
                            v-model="form.wizard2.alamat"
                            type="text"
                            class="form-control"
                            :placeholder="
                            $t('form.citizen.placeholder.address')
                            "
                        />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                        <label for="validationCustom04">{{
                            $t("form.citizen.label.dob")
                        }}</label>
                        <input
                            id="validationCustom04"
                            v-model="form.wizard2.tanggal_lahir"
                            type="date"
                            class="form-control"
                        />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                        <label for="validationCustom05">{{
                            $t("form.citizen.label.birthplace")
                        }}</label>
                        <input
                            id="validationCustom05"
                            v-model="form.wizard2.tempat_lahir"
                            type="text"
                            class="form-control"
                            :placeholder="
                            $t('form.citizen.placeholder.birthplace')
                            "
                        />
                        </div>
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-sm-4"></div>
                    <div class="col-sm-4"></div>
                    <div class="col-sm-4">
                        <div class="form-group">
                        <label
                            ><b>{{
                            $t("form.citizen.label.search-range")
                            }}</b></label
                        >
                        <vue-slide-bar
                            ref="slidebar"
                            v-model="search_value"
                            :min="0"
                            :max="1000"
                        />
                        <b-button-group class="mt-1 btn-group-sm">
                            <b-button
                            variant="secondary"
                            @click="search_value -= 1"
                            >
                            <i class="fas fa-minus"></i>
                            </b-button>
                            <b-form-input
                            ref="input-size"
                            size="sm"
                            for="text"
                            :value="search_value"
                            maxlength="4"
                            v-model="search_value"
                            style="width: 50px"
                            ></b-form-input>
                            <b-button
                            variant="secondary"
                            @click="search_value += 1"
                            >
                            <i class="fas fa-plus"></i>
                            </b-button>
                        </b-button-group>
                        </div>
                        <button
                        class="btn btn-block btn-primary float-right"
                        type="submit"
                        >
                        <b-spinner
                            small
                            v-if="loading"
                            class="mr-2"
                        ></b-spinner>
                        <span v-if="loading">{{
                            $t("button.search.loading")
                        }}</span>
                        <i
                            class="fas fa-search mr-2"
                            v-if="!loading"
                        ></i>
                        <span v-if="!loading">{{
                            $t("button.search.label")
                        }}</span>
                        </button>
                    </div>
                    </div>
                </form>
                </div>
            </div>
            <!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
        <!-- <Table :isSearch="isSearch" :searchData="searchRes"/> -->
        <div class="row mt-3" v-if="tableData[0]">
            <div class="col-12">
            <div class="card">
                <div class="card-body">
                <h5 class="card-title">
                    {{ $t("table.header-label") }}
                </h5>
                <div class="row mt-4">
                    <div class="col-sm-12 col-md-6">
                    <div
                        id="tickets-table_length"
                        class="dataTables_length"
                    >
                        <label class="d-inline-flex align-items-center">
                        {{ $t("table.show-label") }}&nbsp;
                        <b-form-select
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;{{ $t("table.entri-label") }}
                        </label>
                    </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                    <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-right"
                    >
                        <label class="d-inline-flex align-items-center">
                        {{ $t("button.search.label") }}:
                        <b-form-input
                            v-model="filter"
                            type="search"
                            :placeholder="$t('navbar.search.text')"
                            class="form-control form-control-sm ml-2"
                        ></b-form-input>
                        </label>
                    </div>
                    </div>
                    <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                    <b-table
                    :items="tableData"
                    :fields="fields"
                    bordered
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                    show-empty
                    >
                    <template #empty>
                        <h6 class="text-center">
                        {{ $t("table.empty-text") }}
                        </h6>
                    </template>
                    <template #cell(actions)="row">
                        <b-button
                        v-if="
                            selectedItem != 0 &&
                            selectedItem[0].nik == row.item.nik
                        "
                        class="mx-1 my-1 btn-sm btn-success btn"
                        >
                        <i class="fas fa-user-check"></i>
                        </b-button>
                        <b-button
                        v-if="
                            selectedItem != 0 &&
                            selectedItem[0].nik == row.item.nik
                            ? false
                            : true
                        "
                        class="mx-1 my-1 btn-sm btn-secondary btn"
                        @click="selectCitizen(row.item)"
                        >
                        <i class="fas fa-user-plus"></i>
                        </b-button>
                        <b-button
                        class="mx-1 my-1 btn-sm btn-secondary btn"
                        @click="
                            openMapsModal(row.item.nik, row.item.alamat)
                        "
                        >
                        <i class="fas fa-map-marker-alt"></i>
                        </b-button>
                        <b-modal
                        size="xl"
                        hide-footer
                        :id="'modal-maps' + row.item.nik"
                        centered
                        :title="'Location'"
                        title-class="font-18"
                        >
                        <div class="row">
                            <div class="col-lg-12">
                            <gmap-map
                                ref="mymap"
                                :center="{
                                lat: citizen_lat,
                                lng: citizen_long,
                                }"
                                :zoom="18"
                                style="height: 80vh"
                            >
                                <gmap-marker
                                :position="
                                    google &&
                                    new google.maps.LatLng(
                                    citizen_lat,
                                    citizen_long
                                    )
                                "
                                ></gmap-marker>
                            </gmap-map>
                            </div>
                        </div>
                        </b-modal>
                        <!-- <b-button class="mx-1 my-1 btn-sm btn-danger btn" @click="onDelete(row.item.nik)">
                        <i class="fas fa-trash"></i>
                        </b-button> -->
                    </template>
                    </b-table>
                </div>
                <div class="row">
                    <div class="col">
                    <div
                        class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-right
                        "
                    >
                        <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                        </ul>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        <div
            class="row mt-3"
            v-if="
            !tableData[0] && searchCitizen && error == '' && !loading
            "
        >
            <div class="col-12">
            <div class="card pt-5 pb-5">
                <div class="card-body p-5">
                <h6 class="text-center text-secondary">
                    {{ $t("all.dnf") }}
                </h6>
                </div>
            </div>
            </div>
        </div>

        <div
            class="row mt-3"
            v-if="
            !tableData[0] && searchCitizen && error !== '' && !loading
            "
        >
            <div class="col-12">
            <div class="card pt-5 pb-5">
                <div class="card-body p-5">
                <h6 class="text-center text-secondary">{{ error }}</h6>
                </div>
            </div>
            </div>
        </div>
        <!-- end row -->
    </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import Vue from "vue";
import VueSlideBar from "vue-slide-bar";
import CitizenService from "@/helpers/citizen.service";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import TargetService from "@/helpers/target-profile.service";
import { gmapApi } from "vue2-google-maps";
import PreferenceService from "@/helpers/preference.service.js";
import Swal from "sweetalert2";

/**
 * Form wizard component
 */
export default {
  props: {
    "doValidation": Boolean,
    "idTarget": { type: String, default: "" },
  },
  components: {
    VueSlideBar,
    FormWizard,
    TabContent,
  },
  watch: {
    doValidation: {
      immediate: true,
      handler(n) {
        if (n) {
          this.validationWizard();
        }
      },
    },
  },
  data() {
    return {
        form: {
            wizard2: {
            nama: "",
            nik: "",
            nkk: "",
            alamat: "",
            tanggal_lahir: "",
            tempat_lahir: "",
            },
        },
        fields: [
            { key: "nama", label: "Name", sortable: true },
            { key: "nik", label: "NIK", sortable: true },
            { key: "nkk", label: "NKK", sortable: true },
            { key: "tempat_lahir", label: "Birth Place", sortable: true },
            { key: "tanggal_lahir", label: "Date of Birth", sortable: true },
            { key: "actions", label: "Action" },
        ],
        wizard_validation2: {
            invalid: false,
        },
        geocoder: null,
        citizen_lat: 0,
        citizen_long: 0,
        searchCitizen: false,
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: "name",
        sortDesc: false,
        tableData: [],
        selectedItem: [],
        loading: false,
        search_value: 0,
        valid: true,
        submitted: false,
        doValidation2 : false,
    };
  },

  computed: {
    google: gmapApi,
    rows() {
      return this.tableData.length;
    },
  },

  validations: {
    form: {
      wizard2: {
        nama: { required },
        nik: {},
        nkk: {},
        alamat: {},
        tanggal_lahir: {},
        tempat_lahir: {},
      },
    },
  },

  methods: {

    //================================== wizard 2 ===================================//
    /* =======================================
         setup datatable & validation input parameters citizen
         =======================================
      */
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    checkInput() {
      this.submitted = true;
      this.$v.form.wizard2.$touch();
      if (
        (this.form.wizard2.nama == "" &&
          this.form.wizard2.nik == "" &&
          this.form.wizard2.nkk == "" &&
          this.form.wizard2.alamat == "" &&
          this.form.wizard2.tanggal_lahir == "" &&
          this.form.wizard2.tempat_lahir == "") ||
        this.$v.form.wizard2.$invalid
      ) {
        this.valid = false;
      } else {
        this.valid = true;
      }
    },
    /** ======================================*/

    /* =======================================
         search citizen data
         =======================================
      */
    searchData() {
      this.error = "";
      this.searchCitizen = true;
      let query;
      let data = {
        size: this.search_value,
        query: {
          bool: {
            filter: [
              {
                bool: {
                  filter: [],
                },
              },
            ],
          },
        },
      };
      if (data.query.bool.filter[0].bool.filter.length != 0) {
        data.query.bool.filter[0].bool.filter.push([]);
      }
      if (this.form.wizard2.nama != "") {
        const key = this.form.wizard2.nama.split(" ");
        for (let i = 0; i < key.length; i++) {
          query = {
            bool: {
              should: [{ match_phrase: { nama: key[i] } }],
              minimum_should_match: 1,
            },
          };
          data.query.bool.filter[0].bool.filter.push(query);
        }
      }
      if (this.form.wizard2.nik != "") {
        query = {
          bool: {
            should: [{ match_phrase: { nik: this.form.wizard2.nik } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }
      if (this.form.wizard2.nkk != "") {
        query = {
          bool: {
            should: [{ match_phrase: { nkk: this.form.wizard2.nkk } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }
      if (this.form.wizard2.alamat != "") {
        query = {
          bool: {
            should: [{ match_phrase: { alamat: this.form.wizard2.alamat } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }
      if (this.form.wizard2.tanggal_lahir != "") {
        query = {
          bool: {
            should: [
              {
                range: {
                  tanggal_lahir: {
                    gte: this.formatDate(this.form.wizard2.tanggal_lahir),
                    lte: this.formatDate(this.form.wizard2.tanggal_lahir),
                    time_zone: "Asia/Jakarta",
                  },
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }
      if (this.form.wizard2.tempat_lahir != "") {
        query = {
          bool: {
            should: [
              {
                match_phrase: { tempat_lahir: this.form.wizard2.tempat_lahir },
              },
            ],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }

      this.checkInput();
      if (this.valid) {
        this.loading = true;
        this.resetTable();
        CitizenService.search(this.elastic, data)
          .then((response) => {
            this.resetTable();
            response.data.hits.hits.forEach((val) => {
              const data = {
                nama: val._source.nama,
                nik: val._source.nik,
                nkk: val._source.nkk,
                tempat_lahir: val._source.tempat_lahir,
                tanggal_lahir: val._source.tanggal_lahir,
                jenis_kelamin: val._source.jenis_kelamin,
                alamat: val._source.alamat,
                jenis_kelamin: val._source.jenis_kelamin,
                kawin: val._source.kawin,
                pekerjaan: val._source.pekerjaan,
              };
              this.tableData.push(data);
              this.loading = false;
            });
          })
          .catch((err) => {
            if (err.response.status == 500) {
              this.error = "Internal server Error";
            } else if (err.response.status == 404) {
              this.error = "Server Not Found";
            } else if (err.response.status == 403) {
              this.error = "Forbidden";
            }
          });
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      }
    },
    /** ======================================*/

    /* =======================================
         save citizen data
         =======================================
      */
    async saveCitizen() {
    //   let result = false;
      if (this.selectedItem != 0) {
        if (
          this.idTarget == ""
        ) {
        //   this.loadingProcess = true;
        //   this.statusProcess = "process";
        //   this.messageProcess = "Saving citizen data target ..";
          const formCreate = new FormData();
          formCreate.append("name", this.selectedItem[0].nama);
          formCreate.append("nik", this.selectedItem[0].nik);
          formCreate.append("nkk", this.selectedItem[0].nkk);
          formCreate.append("birth_place", this.selectedItem[0].tempat_lahir);
          formCreate.append(
            "date_of_birth",
            this.selectedItem[0].tanggal_lahir
          );
          formCreate.append("gender", this.selectedItem[0].jenis_kelamin);
          formCreate.append("address", this.selectedItem[0].alamat);
          formCreate.append("marriage_status", this.selectedItem[0].kawin);
          formCreate.append("profession", this.selectedItem[0].pekerjaan);
          await CitizenService.create(formCreate)
            .then((response) => {
                this.$emit("id-target", response.data.data.id_target);
                this.$emit("next-tab");
            //   this.wizard_validation2.id_record = response.data.data.id_citizen;
            //   this.statusProcess = true;
              const dataUpdate = new FormData();
              dataUpdate.append("id_citizen", response.data.data.id_citizen);
              this.updateTarget(dataUpdate);
            //   this.wizard_validation2.status = "sent";
            //   this.messageProcess = "Success saving citizen data";
            //   setTimeout(() => {
            //     this.loadingProcess = false;
            //   }, 500);
            })
            .catch((err) => {
            //   this.statusProcess = false;
            //   this.messageProcess = "Failed saving citizen data";
            //   setTimeout(() => {
            //     this.loadingProcess = false;
            //   }, 500);
            //   console.log(err);
            });
        } else if (
          this.idTarget != ""
        ) {
        //   this.loadingProcess = true;
        //   this.statusProcess = "process";
        //   this.messageProcess = "Updating citizen data target ..";
          const formUpdate = new FormData();
          formUpdate.append("name", this.selectedItem[0].nama);
          formUpdate.append("nik", this.selectedItem[0].nik);
          formUpdate.append("nkk", this.selectedItem[0].nkk);
          formUpdate.append("birth_place", this.selectedItem[0].tempat_lahir);
          formUpdate.append(
            "date_of_birth",
            this.selectedItem[0].tanggal_lahir
          );
          formUpdate.append("gender", this.selectedItem[0].jenis_kelamin);
          formUpdate.append("address", this.selectedItem[0].alamat);
          formUpdate.append("marriage_status", this.selectedItem[0].kawin);
          formUpdate.append("profession", this.selectedItem[0].pekerjaan);
          await CitizenService.update(
            this.wizard_validation.id_record,
            formUpdate
          )
            .then((response) => {
                this.$emit("id-target", response.data.data.id_target);
                this.$emit("next-tab");
            //   this.wizard_validation2.status = "sent";
            //   this.statusProcess = true;
            //   this.messageProcess = "Success updating citizen data";
            //   setTimeout(() => {
            //     this.loadingProcess = false;
            //   }, 500);
            })
            .catch((err) => {
            //   this.statusProcess = false;
            //   this.messageProcess = "Failed updating citizen data";
            //   setTimeout(() => {
            //     this.loadingProcess = false;
            //   }, 500);
            //   console.log(err);
            });
        }
      }
    },
    /** ======================================*/

    /* =======================================
         handling for select citizen data
         =======================================
      */
    selectCitizen(item) {
      this.selectedItem = [];
      this.selectedItem.push(item);
      this.form.wizard2.nama = item.nama;
      this.form.wizard2.nik = item.nik;
      this.form.wizard2.nkk = item.nkk;
      this.form.wizard2.alamat = item.alamat;
      this.form.wizard2.tanggal_lahir = item.tanggal_lahir;
      this.form.wizard2.tempat_lahir = item.tempat_lahir;
    },
    /** ======================================*/

    /* =======================================
         open map modal and show location of citizen address
         =======================================
      */
    openMapsModal(id, alamat) {
      this.geocoder.geocode({ address: alamat }, (results, status) => {
        this.citizen_lat = results[0].geometry.location.lat();
        this.citizen_long = results[0].geometry.location.lng();
      });
      this.$bvModal.show("modal-maps" + id);
    },
    /** ======================================*/

    /* =======================================
          validation next button wizard 2
          =======================================
      */
    validationWizard() {
        this.submitted = true;
        this.$v.form.wizard2.$touch();
        this.wizard_validation2.invalid = this.$v.form.wizard2.$invalid;
        if (this.wizard_validation2.invalid) {
            this.$emit("validation-failed");
        }else{
            this.saveCitizen();
        }
    //   let flag = false;
    //   let result = await this.saveCitizen();
    //   await new Promise((resolve, reject) => {
    //     setTimeout(function () {
    //       flag = true;
    //       resolve("valid");
    //     }, 1500);
    //   }).then();
    //   return flag;
    },
    /** ======================================*/
    //================================== wizard 2 ===================================//

    //================================== support ===================================//
    getPreferences() {
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateTarget(data) {
      TargetService.update(this.wizard_validation.id_record, data)
        .then((response) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    resetTable() {
      this.tableData = [];
    },
    typeForm(e) {
      this.typesubmit = true;
      this.$v.$touch();
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    refreshSlider() {
      this.$watch(
        () => this.$refs.formwizard.activeTabIndex,
        () => {
          if (this.$refs.formwizard.activeTabIndex == 1) {
            this.$refs.slidebar.refresh();
          }
        }
      );
    },
    //================================== support ===================================//
  },
  beforeMount() {
    this.getPreferences();
  },
  mounted() {
    this.$gmapApiPromiseLazy().then(() => {
      if (this.google) {
        this.geocoder = new this.google.maps.Geocoder();
      }
    });
    // this.availableOptions;
    // this.totalRows = this.items.length;
    this.search_value = 100;
  },
};
</script>

<style scoped>
/* .par {
  position: relative;
}

.cursor-pointer:hover {
  cursor: pointer;
}
.header-accordion-result:hover {
  cursor: pointer;
}
#tab-username {
  padding: 0;
} */
</style>
